export default __webpack_public_path__ + "static/media/Halberd of the Archaeologian.cb5db68b.jpg";